import { Box, Typography } from "@mui/material";
import { useRoles } from "@/hooks/useRoles";
import type { Role } from "@/lib/roles";

// Colours are FE presentation. Partial + fallback so a new backend role never breaks
// the build — it just renders with the neutral default until someone styles it.
const ROLE_CHIP: Partial<Record<Role, { bg: string; color: string }>> = {
  VIEW_ONLY: { bg: "var(--color-wax)", color: "var(--color-graphite)" },
  MANAGER: { bg: "var(--color-good-night-4)", color: "var(--color-good-night)" },
  CLIENT_ADMIN: { bg: "var(--color-good-sage-4)", color: "var(--color-good-sage)" },
  GFG_STANDARD_ADMIN: { bg: "var(--color-good-ochre-4)", color: "var(--color-good-ochre)" },
  GFG_SUPER_ADMIN: { bg: "var(--color-good-wine-4)", color: "var(--color-good-wine)" },
};

const DEFAULT_CHIP = { bg: "var(--color-wax)", color: "var(--color-graphite)" };

interface RoleChipProps {
  role: Role;
}

export default function RoleChip({ role }: RoleChipProps) {
  const { labelFor } = useRoles();
  const { bg, color } = ROLE_CHIP[role] ?? DEFAULT_CHIP;
  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        bgcolor: bg,
        borderRadius: "9999px",
        px: 1.5,
        py: 0.5,
      }}
    >
      <Typography
        sx={{
          color,
          fontSize: 12,
          fontWeight: 600,
          letterSpacing: "0.06em",
          textTransform: "uppercase",
          lineHeight: 1,
          whiteSpace: "nowrap",
        }}
      >
        {labelFor(role)}
      </Typography>
    </Box>
  );
}
